import { getBaseValueForEffectivePurchase, calculateEffectivePurchase } from "../../../../utils/utils";

/**
 * Estratégia: verifica se há itens elegíveis para ordem de compra
 * considerando os inputs editados pelo usuário.
 * Utilizada em contextos onde o usuário pode ter alterado quantidades.
 */
export const withUserInputs = ({ filteredData, inputs }) => {
  if (!filteredData?.length) return false;

  return filteredData.some(item => {
    const data = { inputs, item, conditionValue: true };

    if (getBaseValueForEffectivePurchase({ data }) > 0) return true;

    const fallbackValue = calculateEffectivePurchase(
      item.initialPurchaseRecommendation,
      item.packToUnitRatio
    );

    return fallbackValue > 0;
  });
};